import { File } from "@/types/app/file";
import { DescriptionDetails, DescriptionList, DescriptionTerm } from "../DescriptionList";
import { isEmpty } from "lodash";
import CodePreview from "../Code/CodePreview";
import { PageSectionHeader } from "@components/library/PageSectionHeader";

export const AttributeDetails = (props: File) => {
  if (isEmpty(props.attributes)) {
    return null;
  }

  return (
    <div className="mt-24">
      <PageSectionHeader title="Attributes" size="sm" />
      <DescriptionList className="-mt-24">
        <DescriptionTerm />
        <DescriptionDetails>
          <CodePreview language="json" wrapLongLines className="text-12-16">
            {JSON.stringify(props.attributes, null, 2)}
          </CodePreview>
        </DescriptionDetails>
      </DescriptionList>
    </div>
  );
};
